export default __webpack_public_path__ + "static/media/Scan-Room.4774fe13.jpg";